import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectassignmentPage } from './projectassignment';

@NgModule({
  declarations: [
    ProjectassignmentPage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectassignmentPage),
  ],
})
export class ProjectassignmentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/projectassignment/projectassignment.module.ts